<template>
  <div class="app-item" :class="[`app-item--${app.code}`]">
    <div class="app-item__outer">
      <div @click="showPlayer" class="app-item__image" :class="[bgImage]"></div>

      <div class="app-item__name">{{ app.name }}</div>
      <div class="app-item__description" v-html="$t(app.description)"></div>

      <template v-if="canShowInfoAvailableText">
        <div class="app-item__description" v-if="language === 'en'">
          Available <a @click="changeLanguage('ru')">Russian</a> and
          <a @click="changeLanguage('fr')">French</a> versions.
        </div>
        <div class="app-item__description" v-if="language === 'fr'">
          Disponible aussi <a @click="changeLanguage('ru')">en russe</a>.
        </div>
      </template>

      <div v-if="app.video" @click="showPlayer" class="app-item__play">
        <svg
          width="15"
          height="16"
          viewBox="0 0 15 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13.1543 6.26772C14.4876 7.03752 14.4876 8.96203 13.1543 9.73183L3.28891 15.4276C1.95558 16.1974 0.288911 15.2352 0.288911 13.6956L0.288912 2.30399C0.288912 0.764392 1.95558 -0.19786 3.28891 0.571941L13.1543 6.26772Z"
            fill="white"
          />
        </svg>
        {{
          app.code === "academy" ? $t("watch_video_academy") : $t("watch_video")
        }}
      </div>

      <a
          v-if="app.link"
          :href="app.link"
          target="_blank"
          class="app-item__play">
        <svg
            width="15"
            height="16"
            viewBox="0 0 15 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
          <path
              d="M13.1543 6.26772C14.4876 7.03752 14.4876 8.96203 13.1543 9.73183L3.28891 15.4276C1.95558 16.1974 0.288911 15.2352 0.288911 13.6956L0.288912 2.30399C0.288912 0.764392 1.95558 -0.19786 3.28891 0.571941L13.1543 6.26772Z"
              fill="white"
          />
        </svg>
        {{ $t("watch_video_academy") }}
      </a>

      <ul v-if="canShowButtons" class="app-item__buttons">
        <li v-for="(button, i) in app.buttons" :key="i">
          <a :href="button.reference" :class="[app.code]">
            <svg
              :width="button.svg.width"
              :height="button.svg.height"
              :viewBox="`0 0 ${button.svg.width} ${button.svg.height}`"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              v-html="button.svg.path"></svg>
            <span v-html="$t(button.platform)"></span>
          </a>
        </li>
      </ul>
    </div>
    <div v-if="app.code === 'academy' || app.code === 'hr-academy'" class="app-item__support">
      <!-- <div class="opacity">{{ $t("support_label") }}</div> -->
      <div>
        <a href="mailto:support@e-queo.com" target="_top">support@e-queo.com, </a>
        <a href="tel:88002348430">8-800-234-84-30</a>
      </div>
    </div>

    <div v-if="app.code === 'info'" class="app-item__support">
      <!-- <div class="opacity">{{ $t("support_info_label") }}</div> -->
      <div>
        <a href="mailto:novosti@nordgold.com" target="_top">novosti@nordgold.com, </a>
        <a href="tel:88002348430">8-800-444-09-90</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "app-item",

  props: {
    app: {
      type: Object,
      default: null,
    },
  },

  data: () => ({}),

  computed: {
    ...mapGetters(["language"]),

    videoId() {
      switch (this.language) {
        case "en":
          return this.app.video.en;
        case "fr":
          return this.app.video.fr;
        default:
          return this.app.video.ru;
      }
    },

    canShowInfoAvailableText() {
      return (
        this.app.code === "info" &&
        (this.language === "en" || this.language === "fr")
      );
    },

    canShowButtons() {
      return this.app.code === "academy" || this.app.code === "hr-academy" || this.language === "ru";
    },

    bgImage() {
      return `app-item__image--${this.app.code}-${this.language}`;
    },
  },

  methods: {
    changeLanguage(lang) {
      this.$i18n.locale = lang;
      this.$store.dispatch("changeLanguage", lang);
    },

    showPlayer() {
      this.$emit("showPlayer", this.videoId);
    },
  },
};
</script>
